angular.module('impactx.panel').controller('ProductPreviewPanelCtrl', [
    '$scope',
    'TranslationService',
    'panelService',
    'ImageEditor',
    ProductPreviewPanelCtrl]);

function ProductPreviewPanelCtrl($scope, TranslationService, panelService, ImageEditor) {
    var self = this;
    $scope.productLabel = TranslationService.get('product');
    self.getProductPanelColor = panelService.getProductPanelColor;

    self.$onChanges = function (changes) {
        if (changes) {
            if (!angular.equals(changes.fallbackImage.previousValue, changes.fallbackImage.currentValue)) {
                self.fallbackImage = changes.fallbackImage.currentValue;
            }
        }
    };

    self.deleteImage = function (event) {
        if (event) {
            event.stopPropagation();
            event.preventDefault();
        }
        self.image.isDeleted = true;
        self.image.file = undefined;
        self.image.url = undefined;
    };

    self.openEditor = function (event, currentImage, newImage) {
        ImageEditor.open(event, currentImage, newImage, 'square').then(function (croppedImage) {
            if(!croppedImage) {
                return
            } else if (!croppedImage.image) {
                self.deleteImage(event);
            } else {
                self.image.file = croppedImage.image;
                self.image.fileName = croppedImage.name;
                self.image.isDeleted = true;
            }
        })
    };

    $scope.$watch(function () {
        return impactX.isDefined(self, "image.file");
    }, function (newValue, oldValue) {
        if (newValue && !angular.equals(newValue, oldValue)) {
            self.image.isDeleted = true;
        }
    });
}